import { render, staticRenderFns } from "./ImportPointScoreModal.vue?vue&type=template&id=38a4030e"
import script from "./ImportPointScoreModal.vue?vue&type=script&lang=js"
export * from "./ImportPointScoreModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports